import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
} from '@mui/material';

export const DialogGlobalAlertContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    width: '100%',
    maxWidth: 500,
  },
});

export const DialogGlobalAlertHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  padding: theme.spacing(2, 3),
  flex: '0 0 auto',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.main,
  color: '#00e5ff',
}));

export const DialogGlobalAlertContent = styled(DialogContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const DialogGlobalAlertActions = styled(DialogActions)({
  justifyContent: 'space-between',
});
